// Hand-written: multipart upload and the raw file route are not covered by the
// generated client. This lives outside src/api because regenerating the client
// wipes that directory.
export async function chatUploadDocument(params: {
    file: File;
    tag_ids: number[];
}) {
    const body = new FormData();
    body.append("file", params.file);
    body.append("tag_ids", JSON.stringify(params.tag_ids));
    const res = await fetch("/api/chatchat-upload-document", {
        method: "POST",
        body,
        credentials: "include",
    });
    const data = await res.json().catch(() => undefined);
    if (!res.ok) {
        const detail = data?.detail;
        const message = typeof detail === "string" ? detail : undefined;
        return { data: undefined, error: { detail: message || res.statusText, body: data } };
    }
    return { data, error: undefined };
}

export function documentFileUrl(documentId: number) {
    return `/api/documents/${documentId}/file`;
}
